module.exports = __webpack_public_path__ + "img/i01.e5e9565d.svg";